import type { SVGProps } from 'react'

const EscIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="6"
    viewBox="0 0 16 6"
    fill="none"
    aria-label="Escape key"
    role="img"
    {...props}
  >
    <path
      d="M2.76778 5.09587C2.27559 5.09587 1.85052 4.9936 1.49256 4.78905C1.13674 4.58238 0.862948 4.29047 0.671187 3.91334C0.479426 3.53408 0.383545 3.0877 0.383545 2.57421C0.383545 2.06924 0.479426 1.62605 0.671187 1.24466C0.865079 0.861139 1.13568 0.562844 1.48298 0.349776C1.83028 0.134577 2.2383 0.0269775 2.70705 0.0269775C3.00961 0.0269775 3.29512 0.0759834 3.56359 0.173995C3.83418 0.269875 4.07282 0.419023 4.2795 0.621438C4.4883 0.823853 4.65237 1.08167 4.77168 1.39488C4.891 1.70596 4.95066 2.07669 4.95066 2.50709V2.86185H0.926869V2.08202H3.84164C3.83951 1.86043 3.79157 1.66334 3.69782 1.49076C3.60407 1.31604 3.47303 1.17861 3.30471 1.07847C3.13852 0.978327 2.94462 0.928256 2.72303 0.928256C2.48653 0.928256 2.27879 0.985784 2.09981 1.10084C1.92083 1.21377 1.78127 1.36291 1.68113 1.54828C1.58312 1.73152 1.53305 1.93287 1.53092 2.15233V2.83309C1.53092 3.1186 1.58312 3.36363 1.68752 3.56817C1.79193 3.77059 1.93788 3.92613 2.12538 4.03479C2.31288 4.14132 2.53234 4.19459 2.78376 4.19459C2.95208 4.19459 3.10443 4.17115 3.24079 4.12428C3.37715 4.07527 3.49541 4.0039 3.59555 3.91015C3.69569 3.8164 3.77133 3.70027 3.82247 3.56178L4.90272 3.68323C4.83454 3.96874 4.70457 4.21803 4.51281 4.4311C4.32318 4.64203 4.08028 4.8061 3.78411 4.92328C3.48795 5.03834 3.14917 5.09587 2.76778 5.09587Z"
      fill="currentColor"
    />
    <path
      d="M9.80941 1.38848L8.75473 1.50354C8.7249 1.39701 8.6727 1.29686 8.59812 1.20311C8.52568 1.10936 8.42767 1.03372 8.30409 0.976196C8.18051 0.918668 8.02923 0.889904 7.85025 0.889904C7.60949 0.889904 7.40707 0.942105 7.24301 1.04651C7.08108 1.15091 7.00118 1.28621 7.00331 1.4524C7.00118 1.59516 7.05338 1.71128 7.15991 1.80077C7.26858 1.89026 7.44755 1.96377 7.69684 2.0213L8.5342 2.20027C8.99869 2.30042 9.34386 2.45915 9.56971 2.67648C9.7977 2.89381 9.91275 3.17826 9.91488 3.52982C9.91275 3.83877 9.8222 4.11149 9.64322 4.348C9.46638 4.58238 9.22028 4.76561 8.90494 4.89772C8.5896 5.02982 8.22738 5.09587 7.81829 5.09587C7.21744 5.09587 6.73378 4.97016 6.3673 4.71874C6.00082 4.46519 5.78243 4.11256 5.71211 3.66086L6.84031 3.55219C6.89145 3.77378 7.00011 3.94104 7.1663 4.05397C7.3325 4.16689 7.54876 4.22336 7.8151 4.22336C8.08995 4.22336 8.31048 4.16689 8.47667 4.05397C8.645 3.94104 8.72916 3.80148 8.72916 3.63529C8.72916 3.49466 8.67483 3.37854 8.56616 3.28692C8.45963 3.1953 8.29344 3.12499 8.06758 3.07598L7.23023 2.9002C6.75934 2.80219 6.41098 2.63706 6.18513 2.40482C5.95927 2.17044 5.84741 1.87428 5.84954 1.51632C5.84741 1.21377 5.92944 0.951694 6.09564 0.730103C6.26396 0.506381 6.49727 0.333796 6.79557 0.212347C7.09599 0.0887672 7.44223 0.0269775 7.83427 0.0269775C8.40956 0.0269775 8.86233 0.149492 9.19258 0.39452C9.52497 0.639549 9.73058 0.97087 9.80941 1.38848Z"
      fill="currentColor"
    />
    <path
      d="M13.0102 5.09587C12.5202 5.09587 12.0994 4.98827 11.7478 4.77307C11.3984 4.55787 11.1288 4.26064 10.9392 3.88138C10.7517 3.49999 10.658 3.06107 10.658 2.56462C10.658 2.06604 10.7538 1.62605 10.9456 1.24466C11.1374 0.861139 11.408 0.562844 11.7574 0.349776C12.109 0.134577 12.5244 0.0269775 13.0038 0.0269775C13.4023 0.0269775 13.7549 0.100486 14.0617 0.247503C14.3707 0.392389 14.6168 0.598 14.8 0.864336C14.9832 1.12854 15.0876 1.43749 15.1132 1.79118H14.0074C13.9626 1.55468 13.8561 1.35759 13.6878 1.19992C13.5216 1.04012 13.2989 0.960216 13.0198 0.960216C12.7833 0.960216 12.5756 1.02414 12.3966 1.15198C12.2176 1.27769 12.0781 1.4588 11.9779 1.6953C11.8799 1.93181 11.8309 2.21519 11.8309 2.54544C11.8309 2.87996 11.8799 3.1676 11.9779 3.40837C12.0759 3.64701 12.2134 3.83131 12.3902 3.96128C12.5692 4.08912 12.7791 4.15304 13.0198 4.15304C13.1903 4.15304 13.3426 4.12108 13.4769 4.05716C13.6132 3.99111 13.7272 3.8963 13.8188 3.77272C13.9104 3.64914 13.9733 3.49892 14.0074 3.32208H15.1132C15.0855 3.66938 14.9832 3.97726 14.8064 4.24573C14.6295 4.51206 14.3888 4.72087 14.0841 4.87215C13.7794 5.0213 13.4215 5.09587 13.0102 5.09587Z"
      fill="currentColor"
    />
  </svg>
)

const CaretDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Arrow down"
    role="img"
    {...props}
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <polyline points="19 12 12 19 5 12" />
  </svg>
)

const CaretUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Arrow up"
    role="img"
    {...props}
  >
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
)

const CaretRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    aria-label="Arrow right"
    role="img"
    {...props}
  >
    <path
      d="M14.192 10.4423L7.94205 16.6923C7.88398 16.7504 7.81504 16.7964 7.73917 16.8278C7.6633 16.8593 7.58198 16.8755 7.49986 16.8755C7.41774 16.8755 7.33642 16.8593 7.26055 16.8278C7.18468 16.7964 7.11574 16.7504 7.05767 16.6923C6.9996 16.6342 6.95354 16.5653 6.92211 16.4894C6.89069 16.4135 6.87451 16.3322 6.87451 16.2501C6.87451 16.168 6.89069 16.0867 6.92211 16.0108C6.95354 15.9349 6.9996 15.866 7.05767 15.8079L12.8663 10.0001L7.05767 4.19229C6.9404 4.07502 6.87451 3.91596 6.87451 3.7501C6.87451 3.58425 6.9404 3.42519 7.05767 3.30792C7.17495 3.19064 7.33401 3.12476 7.49986 3.12476C7.66571 3.12476 7.82477 3.19064 7.94205 3.30792L14.192 9.55792C14.2502 9.61596 14.2963 9.68489 14.3277 9.76077C14.3592 9.83664 14.3754 9.91797 14.3754 10.0001C14.3754 10.0822 14.3592 10.1636 14.3277 10.2394C14.2963 10.3153 14.2502 10.3842 14.192 10.4423Z"
      fill="currentColor"
    />
  </svg>
)

const CaretLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-label="Arrow left"
    role="img"
    {...props}
  >
    <path
      d="M15.5306 18.9693C15.6003 19.039 15.6556 19.1217 15.6933 19.2128C15.731 19.3038 15.7504 19.4014 15.7504 19.4999C15.7504 19.5985 15.731 19.6961 15.6933 19.7871C15.6556 19.8781 15.6003 19.9609 15.5306 20.0306C15.4609 20.1002 15.3782 20.1555 15.2872 20.1932C15.1961 20.2309 15.0985 20.2503 15 20.2503C14.9014 20.2503 14.8039 20.2309 14.7128 20.1932C14.6218 20.1555 14.539 20.1002 14.4694 20.0306L6.96935 12.5306C6.89962 12.4609 6.8443 12.3782 6.80656 12.2871C6.76882 12.1961 6.74939 12.0985 6.74939 11.9999C6.74939 11.9014 6.76882 11.8038 6.80656 11.7127C6.8443 11.6217 6.89962 11.539 6.96935 11.4693L14.4694 3.9693C14.6101 3.82857 14.801 3.74951 15 3.74951C15.199 3.74951 15.3899 3.82857 15.5306 3.9693C15.6713 4.11003 15.7504 4.30091 15.7504 4.49993C15.7504 4.69895 15.6713 4.88982 15.5306 5.03055L8.56029 11.9999L15.5306 18.9693Z"
      fill="#7F7D86"
    />
  </svg>
)

const SelectIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Enter key"
    role="img"
    {...props}
  >
    <polyline points="9 10 4 15 9 20" />
    <path d="M20 4v7a4 4 0 0 1-4 4H4" />
  </svg>
)

const HashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 256 256"
    aria-label="Hash"
    role="img"
    {...props}
  >
    <path d="M224,88H175.4l8.47-46.57a8,8,0,0,0-15.74-2.86l-9,49.43H111.4l8.47-46.57a8,8,0,0,0-15.74-2.86L95.14,88H48a8,8,0,0,0,0,16H92.23L83.5,152H32a8,8,0,0,0,0,16H80.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,80,224a8,8,0,0,0,7.86-6.57l9-49.43H144.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,144,224a8,8,0,0,0,7.86-6.57l9-49.43H208a8,8,0,0,0,0-16H163.77l8.73-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.77l8.73-48h47.73Z" />
  </svg>
)
const FileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 256 256"
    aria-label="File"
    role="img"
    {...props}
  >
    <path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" />
  </svg>
)
const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 256 256"
    aria-label="Search"
    role="img"
    {...props}
  >
    <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" />
  </svg>
)

const XIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 256 256"
    aria-label="Close"
    role="img"
    {...props}
  >
    <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" />
  </svg>
)

const StarsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Stars AI"
    role="img"
    {...props}
  >
    <path
      d="M12.3488 8.56625L9.12317 7.37875L7.93567 4.15062C7.86534 3.95958 7.73811 3.7947 7.57114 3.67824C7.40417 3.56178 7.20549 3.49933 7.00192 3.49933C6.79834 3.49933 6.59966 3.56178 6.43269 3.67824C6.26572 3.7947 6.13849 3.95958 6.06817 4.15062L4.87942 7.375L1.65129 8.5625C1.46025 8.63282 1.29537 8.76005 1.17891 8.92702C1.06244 9.094 1 9.29267 1 9.49625C1 9.69983 1.06244 9.8985 1.17891 10.0655C1.29537 10.2324 1.46025 10.3597 1.65129 10.43L4.87504 11.625L6.06254 14.8512C6.13286 15.0423 6.26009 15.2072 6.42707 15.3236C6.59404 15.4401 6.79272 15.5025 6.99629 15.5025C7.19987 15.5025 7.39854 15.4401 7.56552 15.3236C7.73249 15.2072 7.85972 15.0423 7.93004 14.8512L9.11754 11.6256L12.3457 10.4381C12.5367 10.3678 12.7016 10.2406 12.8181 10.0736C12.9345 9.90663 12.997 9.70795 12.997 9.50438C12.997 9.3008 12.9345 9.10212 12.8181 8.93515C12.7016 8.76818 12.5367 8.64095 12.3457 8.57063L12.3488 8.56625ZM8.77442 10.6875C8.6393 10.7371 8.51659 10.8155 8.41482 10.9173C8.31304 11.019 8.23463 11.1418 8.18504 11.2769L6.99754 14.4931L5.81254 11.2744C5.76291 11.14 5.68475 11.0179 5.58344 10.9166C5.48213 10.8153 5.36007 10.7371 5.22567 10.6875L2.00942 9.5L5.22567 8.3125C5.36007 8.26287 5.48213 8.18471 5.58344 8.0834C5.68475 7.98209 5.76291 7.86003 5.81254 7.72563L7.00004 4.50938L8.18754 7.72563C8.23713 7.86074 8.31554 7.98345 8.41732 8.08523C8.51909 8.187 8.6418 8.26541 8.77692 8.315L11.9932 9.5025L8.77442 10.6875ZM9.00004 3C9.00004 2.86739 9.05272 2.74021 9.14649 2.64645C9.24026 2.55268 9.36743 2.5 9.50004 2.5H10.5V1.5C10.5 1.36739 10.5527 1.24021 10.6465 1.14645C10.7403 1.05268 10.8674 1 11 1C11.1326 1 11.2598 1.05268 11.3536 1.14645C11.4474 1.24021 11.5 1.36739 11.5 1.5V2.5H12.5C12.6326 2.5 12.7598 2.55268 12.8536 2.64645C12.9474 2.74021 13 2.86739 13 3C13 3.13261 12.9474 3.25979 12.8536 3.35355C12.7598 3.44732 12.6326 3.5 12.5 3.5H11.5V4.5C11.5 4.63261 11.4474 4.75979 11.3536 4.85355C11.2598 4.94732 11.1326 5 11 5C10.8674 5 10.7403 4.94732 10.6465 4.85355C10.5527 4.75979 10.5 4.63261 10.5 4.5V3.5H9.50004C9.36743 3.5 9.24026 3.44732 9.14649 3.35355C9.05272 3.25979 9.00004 3.13261 9.00004 3ZM15.5 6C15.5 6.13261 15.4474 6.25979 15.3536 6.35355C15.2598 6.44732 15.1326 6.5 15 6.5H14.5V7C14.5 7.13261 14.4474 7.25979 14.3536 7.35355C14.2598 7.44732 14.1326 7.5 14 7.5C13.8674 7.5 13.7403 7.44732 13.6465 7.35355C13.5527 7.25979 13.5 7.13261 13.5 7V6.5H13C12.8674 6.5 12.7403 6.44732 12.6465 6.35355C12.5527 6.25979 12.5 6.13261 12.5 6C12.5 5.86739 12.5527 5.74021 12.6465 5.64645C12.7403 5.55268 12.8674 5.5 13 5.5H13.5V5C13.5 4.86739 13.5527 4.74021 13.6465 4.64645C13.7403 4.55268 13.8674 4.5 14 4.5C14.1326 4.5 14.2598 4.55268 14.3536 4.64645C14.4474 4.74021 14.5 4.86739 14.5 5V5.5H15C15.1326 5.5 15.2598 5.55268 15.3536 5.64645C15.4474 5.74021 15.5 5.86739 15.5 6Z"
      fill="currentColor"
    />
  </svg>
)

const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    aria-label="Star AI"
    role="img"
    {...props}
  >
    <path
      d="M5.5 6.10352e-05L5.70891 0.564629C6.51919 2.75438 8.24568 4.48087 10.4354 5.29115L11 5.50006L10.4354 5.70897C8.24568 6.51925 6.51919 8.24574 5.70891 10.4355L5.5 11.0001L5.29109 10.4355C4.48081 8.24574 2.75432 6.51925 0.564567 5.70897L0 5.50006L0.564568 5.29115C2.75432 4.48087 4.48081 2.75438 5.29109 0.564628L5.5 6.10352e-05Z"
      fill="url(#paint0_radial_203_2981)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_203_2981"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.67742 1.95167) rotate(110.095) scale(7.74573)"
      >
        <stop stopColor="var(--icon-ai-color-primary, #5E6685)" />
        <stop offset="1" stopColor="var(--icon-ai-color-secondary, #CFD8F7)" />
      </radialGradient>
    </defs>
  </svg>
)

export const ReadAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Read more"
    role="img"
    {...props}
  >
    <path
      d="M13.5 3.5V6.5C13.5 6.63261 13.4473 6.75979 13.3536 6.85355C13.2598 6.94732 13.1326 7 13 7C12.8674 7 12.7402 6.94732 12.6464 6.85355C12.5527 6.75979 12.5 6.63261 12.5 6.5V4.70687L9.35375 7.85375C9.25993 7.94757 9.13268 8.00028 9 8.00028C8.86732 8.00028 8.74007 7.94757 8.64625 7.85375C8.55243 7.75993 8.49972 7.63268 8.49972 7.5C8.49972 7.36732 8.55243 7.24007 8.64625 7.14625L11.7931 4H10C9.86739 4 9.74021 3.94732 9.64645 3.85355C9.55268 3.75979 9.5 3.63261 9.5 3.5C9.5 3.36739 9.55268 3.24021 9.64645 3.14645C9.74021 3.05268 9.86739 3 10 3H13C13.1326 3 13.2598 3.05268 13.3536 3.14645C13.4473 3.24021 13.5 3.36739 13.5 3.5ZM6.64625 9.14625L3.5 12.2931V10.5C3.5 10.3674 3.44732 10.2402 3.35355 10.1464C3.25979 10.0527 3.13261 10 3 10C2.86739 10 2.74021 10.0527 2.64645 10.1464C2.55268 10.2402 2.5 10.3674 2.5 10.5V13.5C2.5 13.6326 2.55268 13.7598 2.64645 13.8536C2.74021 13.9473 2.86739 14 3 14H6C6.13261 14 6.25979 13.9473 6.35355 13.8536C6.44732 13.7598 6.5 13.6326 6.5 13.5C6.5 13.3674 6.44732 13.2402 6.35355 13.1464C6.25979 13.0527 6.13261 13 6 13H4.20687L7.35375 9.85375C7.44757 9.75993 7.50028 9.63268 7.50028 9.5C7.50028 9.36732 7.44757 9.24007 7.35375 9.14625C7.25993 9.05243 7.13268 8.99972 7 8.99972C6.86732 8.99972 6.74007 9.05243 6.64625 9.14625Z"
      fill="currentColor"
    />
  </svg>
)

export const ReadLess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Read less"
    role="img"
    {...props}
  >
    <path
      d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"
      fill="currentColor"
    />
  </svg>
)

export {
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  CaretUpIcon,
  EscIcon,
  FileIcon,
  HashIcon,
  SearchIcon,
  SelectIcon,
  StarIcon,
  StarsIcon,
  XIcon
}
